import React, { useRef, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faXmark } from '@fortawesome/free-solid-svg-icons';
import "./interview.css";
import { apiService } from '../../../../services/apiService';
import { toast } from 'react-toastify';
import { faFileLines } from '@fortawesome/free-regular-svg-icons';
function CreateOpportunity() {
    const navigate = useNavigate();
    // const id = localStorage.getItem('userid');
    
    const [formData, setFormData] = useState({
        company_name: '',
        client_name: '',
        site_type: '',
        is_relocation: '',
        job_title: '',
        job_description: '',
        from: '',
        to: '',
        attachment: [],
    });
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [submitloader, setSubmitloader] = useState(false);
    

    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [showSuggestions, setShowSuggestions] = useState(false);

    const fetchSuggestions = async (query) => {
        if (!query) {
            return;
        }
    
        try {
            const response = await apiService.postRequest("locations/suggestions", { "search": query , "type" : "case_management" });
            if(response && response.success){
            setFilteredSuggestions(response.data || [])
            //   setSuggestions(response.tags || []); // Adjust based on API response
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error("Error fetching suggestions:", error);
        }
    };
    const handleInputSuggChange = (e) => {
        const value = e.target.value;
        setFormData({ ...formData, from: value });
        setErrors((prevErrors) => ({
            ...prevErrors,
            from: '',
        }));
        if (value) {
            fetchSuggestions(value);
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const handleSuggestionClick = (suggestion) => {
        setFormData({ ...formData, from: suggestion });
        setShowSuggestions(false);
    };
    const handleKeyDown = (e) => {
        if (e.key === "ArrowDown" && activeIndex < filteredSuggestions.length - 1) {
            setActiveIndex(activeIndex + 1);
        } else if (e.key === "ArrowUp" && activeIndex > 0) {
            setActiveIndex(activeIndex - 1);
        } else if (e.key === "Enter") {
            if (activeIndex >= 0) {
                const selected = filteredSuggestions[activeIndex];
                setFormData({ ...formData, from: selected.label });
                // setLocationQuery(e.target.value)
                setShowSuggestions(false);
            }
        }
    };
    const [filteredSuggestions2, setFilteredSuggestions2] = useState([]);
    const [activeIndex2, setActiveIndex2] = useState(-1);
    const [showSuggestions2, setShowSuggestions2] = useState(false);

    const fetchSuggestions2 = async (query) => {
        if (!query) {
            return;
        }
    
        try {
            const response = await apiService.postRequest("locations/suggestions", { "search": query , "type" : "case_management" });
            if(response && response.success){
            setFilteredSuggestions2(response.data || [])
            //   setSuggestions(response.tags || []); // Adjust based on API response
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error("Error fetching suggestions:", error);
        }
    };
    const handleInputSuggChange2 = (e) => {
        const value = e.target.value;
        setFormData({ ...formData, to: value });
        setErrors((prevErrors) => ({
            ...prevErrors,
            to: '',
        }));
        if (value) {
            fetchSuggestions2(value);
            setShowSuggestions2(true);
        } else {
            setShowSuggestions2(false);
        }
    };

    const handleSuggestionClick2 = (suggestion) => {
        setFormData({ ...formData, to: suggestion });
        setShowSuggestions(false);
    };
    const handleKeyDown2 = (e) => {
        if (e.key === "ArrowDown" && activeIndex2 < filteredSuggestions.length - 1) {
            setActiveIndex2(activeIndex2 + 1);
        } else if (e.key === "ArrowUp" && activeIndex2 > 0) {
            setActiveIndex2(activeIndex2 - 1);
        } else if (e.key === "Enter") {
            if (activeIndex2 >= 0) {
                const selected = filteredSuggestions[activeIndex2];
                setFormData({ ...formData, to: selected.label });
                setShowSuggestions(false);
            }
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
    
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
        setFormData({ ...formData, [name]: value });
    };
    

    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const MAX_FILES = 1;
    const MAX_TOTAL_SIZE_MB = 10;
    const MAX_FILE_SIZE_MB = 10;
    const allowedTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ];

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);

        // Check if total number of files exceeds limit
        if (files.length + selectedFiles.length > MAX_FILES) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                attachment: `You can only upload up to ${MAX_FILES} files.`,
            }));
            return;
        }

        // Check each file size and type
        for (const file of selectedFiles) {
            if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    attachment: `Each file must be less than ${MAX_FILE_SIZE_MB} MB.`,
                }));
                return;
            }
            
            if (!allowedTypes.includes(file.type)) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    attachment: `Only PDF and Word files are allowed.`,
                }));
                return;
            }
        }

        // Check total combined size of all files
        const currentSize = files.reduce((acc, file) => acc + file.file?.size, 0);
        const newSize = selectedFiles.reduce((acc, file) => acc + file?.size, 0);
        if (currentSize + newSize > MAX_TOTAL_SIZE_MB * 1024 * 1024) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                attachment: `Total file size cannot exceed ${MAX_TOTAL_SIZE_MB} MB.`,
            }));
            return;
        }
        
        setErrors((prevErrors) => ({
            ...prevErrors,
            attachment: "",
        }));
        
        const updatedFiles = selectedFiles.map((file) => ({
            file,
            name: file.name,
        }));
        setFiles((prevFiles) => [...prevFiles, ...updatedFiles]);
        fileInputRef.current.value = null;
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFiles = Array.from(event.dataTransfer.files);

        // Check if total number of files exceeds limit
        if (files.length + droppedFiles.length > MAX_FILES) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                attachment: `You can only upload up to ${MAX_FILES} files.`,
            }));
            return;
        }

        // Check each file size and type
        for (const file of droppedFiles) {
            if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    attachment: `Each file must be less than ${MAX_FILE_SIZE_MB} MB.`,
                }));
                return;
            }
            
            if (!allowedTypes.includes(file.type)) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    attachment: `Only PDF and Word files are allowed.`,
                }));
                return;
            }
        }

        // Check total combined size of all files
        const currentSize = files.reduce((acc, file) => acc + file.file.size, 0);
        const newSize = droppedFiles.reduce((acc, file) => acc + file.size, 0);
        if (currentSize + newSize > MAX_TOTAL_SIZE_MB * 1024 * 1024) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                attachment: `Total file size cannot exceed ${MAX_TOTAL_SIZE_MB} MB.`,
            }));
            return;
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            attachment: "",
        }));
        
        const updatedFiles = droppedFiles.map((file) => ({
            file,
            name: file.name,
        }));
        setFiles((prevFiles) => [...prevFiles, ...updatedFiles]);
    };

    const handleRemoveFile = (index) => {
        
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
        fileInputRef.current.value = null;
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };
    const validateForm = () => {
        const newErrors = {};

        if (!formData.job_title) newErrors.job_title = "Job Title is required.";
        if (formData.job_title && formData.job_title.length < 3) {
            newErrors.job_title = "Job Title must be at least 3 characters long.";
        }else if (formData.job_title && formData.job_title.length > 200) {
            newErrors.job_title = 'Job Title be less than 200 characters long.';
        }
        if (!formData.job_description) newErrors.job_description = "Job Description is required.";
        if (formData.job_description && formData.job_description.length < 3) {
            newErrors.job_description = "Job Description must be at least 3 characters long.";
        }else if (formData.job_description && formData.job_description.length > 2000) {
            newErrors.job_description = 'Job Description be less than 2000 characters long.';
        }
        if (!formData.company_name) newErrors.company_name = "Company name is required.";
        if (!formData.client_name) newErrors.client_name = "Client name is required.";
        if (!formData.site_type) newErrors.site_type = "Site type is required.";
        if (!formData.from) newErrors.from = "From is required.";
        if (!formData.to) newErrors.to = "To is required.";
        if (!formData.is_relocation) newErrors.is_relocation = "Candidate Relocation is required.";
        
        if (files.length === 0){
            newErrors.attachment = "Attachments is required.";
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            setErrorMessage('Please fix the errors before proceeding.');
            return;
        }
        setSubmitloader(true);
        try {
            const formDataToSend = new FormData();

            // Add file attachments
            files.forEach((file) => {
                formDataToSend.append('attachment', file.file);
            });

            // Add other form fields
            for (const key in formData) {
                if (formData[key] !== undefined && formData[key] !== null) {
                    formDataToSend.append(key, formData[key]);
                }
            }
            const response = await apiService.postRequest('catalog/interview/opportunity_create', formDataToSend);

            // Check if the response indicates success
            if (response && response.success === true) {
                setErrors({});
                setErrorMessage('');
                setFiles([]);
                navigate("/catalogs/interviews-opportunity");
                toast(response.message || "Submitted Successfully !")
            } else {
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                    setErrors(response.errors);
                }
            }
        } catch (error) {
            console.log("err",error);
        }finally {
            setSubmitloader(false); // Stop loader
        }
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center" justifyContent="space-between">
                    <Grid size={{xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Interviews Booking</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/catalogs/consulting-services")}>Catalog</b><FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/catalogs/interviews-opportunity")}>Interviews Booking</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Add Opportunity</span>
                    </Grid>
                </Grid>
                <Grid size={{md:12,xs:12}} container justifyContent="flex-end" alignItems="center" className="my-4">
                    <form className='w-100 pt-4' onSubmit={handleSubmit} >
                        <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                <span>Company Name<small className='red_starimpo'>*</small></span>
                                <input onChange={handleInputChange} name='company_name' value={formData.company_name || ""} />
                                {errors.company_name && <p style={{color:"Red"}}>{errors.company_name}</p>}
                            </Grid>
                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                <span>Client Name<small className='red_starimpo'>*</small></span>
                                <input onChange={handleInputChange} name='client_name' value={formData.client_name || ""} />
                                {errors.client_name && <p style={{color:"Red"}}>{errors.client_name}</p>}
                            </Grid>
                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                <span>Site Type<small className='red_starimpo'>*</small></span>
                                <select onChange={handleInputChange} name='site_type' value={formData.site_type || ""}>
                                    <option value="">Select</option>
                                    <option value="Remote">Remote</option>
                                    <option value="Onsite">Onsite</option>
                                    <option value="Hybrid">Hybrid</option>
                                </select>
                                {errors.site_type && <p style={{color:"Red"}}>{errors.site_type}</p>}
                            </Grid>
                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                <span>Is the candidate can relocate?<span style={{color:"Red"}}> *</span></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        className='ms-0'
                                        // disabled={!showSubmits}
                                        type="radio" 
                                        name="is_relocation"
                                        value="Yes"cd
                                        checked={formData.is_relocation  === "Yes"} 
                                        onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        className='ms-4'
                                        // disabled={!showSubmits}
                                        type="radio" 
                                        name="is_relocation"
                                        value="No"
                                        checked={formData.is_relocation  === "No"} 
                                        onChange={handleInputChange} 
                                    />No
                                </div>
                                {errors.is_relocation && <p style={{color:"Red"}}>{errors.is_relocation}</p>}
                            </Grid>
                            <Grid size={{ xs:12}} container>
                                <Grid size={{xs:12}} container flexDirection="column">
                                    <span>Job Title<span style={{color:"red"}}> *</span></span>
                                    <input value={formData.job_title} onChange={handleInputChange}
                                        type="text"
                                        name="job_title"
                                        minLength="3"
                                        maxLength="201"
                                    />
                                    {errors.job_title && <p style={{color:"Red"}}>{errors.job_title}</p>}
                                </Grid>
                            </Grid>
                            <Grid size={{sm:12, xs:12}} container flexDirection="column">
                                <span>Job Description<span style={{color:"Red"}}> *</span></span>
                                <textarea placeholder='Describe' minLength="3" maxLength="4001" value={formData.job_description} onChange={handleInputChange} rows="10" name="job_description"/>
                                {errors.job_description && <p style={{color:"Red"}}>{errors.job_description}</p>}
                            </Grid>
                            <Grid size={{xs:12}} container flexDirection="column">
                                <span>Resume <span style={{color:"red"}}> *</span></span>
                                <Grid size={{xs: 12 }} container justifyContent="space-between">
                                    <div
                                        onDrop={handleDrop}
                                        onDragOver={handleDragOver}
                                        className='drag_uploaders align-items-center flex-column d-flex'
                                    >
                                        <FontAwesomeIcon className='file_uploadericon' icon={faFileLines} />
                                        <input
                                            type="file"
                                            multiple
                                            onChange={handleFileChange}
                                            style={{ display: 'none' }}
                                            id="file-upload"
                                            ref={fileInputRef} // Attach the ref here
                                        />
                                        <label htmlFor="file-upload">
                                            Browse Files
                                        </label>
                                        <p className='w-100 mb-0 mt-3'>or drop file here</p>
                                    </div>
                                    {errors.attachment && <p style={{color:"Red"}}>{errors.attachment}</p>}
                                </Grid>
                                <Grid size={{xs:12}} container justifyContent="space-between" className="mt-4">
                                    {files.map((file, index) => (
                                        <Grid key={index} size={{xs:12}} container justifyContent="space-between" alignItems="center" className="tablelisterattach reportincident">
                                            <Grid container className="pinkbgattachreport" alignItems="center">
                                                <span className='spanreport_elipse' style={{whiteSpace: "nowrap"}}>{index + 1}<span className='filenamesshow ms-3'>{file.name}</span></span>
                                                <button onClick={(e) => handleRemoveFile(index)}>
                                                    <FontAwesomeIcon icon={faXmark} />
                                                </button>
                                            </Grid>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                <span>From<span style={{color:"Red"}}> *</span></span>
                                <div className='col-12 px-0' style={{position:"relative"}}>
                                    <input type='text' placeholder='City and State'
                                        value={formData.from}
                                        onChange={handleInputSuggChange}
                                        onKeyDown={handleKeyDown}
                                        onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                                        onFocus={() => setShowSuggestions(true)}
                                    />
                                    {showSuggestions && (
                                        <ul className="suggestions-dropdown">
                                            {filteredSuggestions.length > 0 ? (
                                                filteredSuggestions.map((suggestion, index) => (
                                                    <li
                                                        key={index}
                                                        className={index === activeIndex ? "active" : ""}
                                                        onMouseDown={() => handleSuggestionClick(suggestion.label)}
                                                    >
                                                        {suggestion.label}
                                                    </li>
                                                ))
                                            ) : (
                                                <li className="no-suggestions">No results found</li>
                                            )}
                                        </ul>
                                    )}
                                </div>
                                {errors.from && <p style={{color:"Red"}}>{errors.from}</p>}
                            </Grid>
                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                <span>To<span style={{color:"Red"}}> *</span></span>
                                <div className='col-12 px-0' style={{position:"relative"}}>
                                    <input type='text' placeholder='City and State'
                                        value={formData.to}
                                        onChange={handleInputSuggChange2}
                                        onKeyDown={handleKeyDown2}
                                        onBlur={() => setTimeout(() => setShowSuggestions2(false), 200)}
                                        onFocus={() => setShowSuggestions2(true)}
                                    />
                                    {showSuggestions2 && (
                                        <ul className="suggestions-dropdown">
                                            {filteredSuggestions2.length > 0 ? (
                                                filteredSuggestions2.map((suggestion, index) => (
                                                    <li
                                                        key={index}
                                                        className={index === activeIndex ? "active" : ""}
                                                        onMouseDown={() => handleSuggestionClick2(suggestion.label)}
                                                    >
                                                        {suggestion.label}
                                                    </li>
                                                ))
                                            ) : (
                                                <li className="no-suggestions">No results found</li>
                                            )}
                                        </ul>
                                    )}
                                </div>
                                {errors.to && <p style={{color:"Red"}}>{errors.to}</p>}
                            </Grid>
                            {errorMessage && <div style={{ color: 'red', margin: '10px 0px',width:"100%" }}>{errorMessage}</div>}
                            <Grid size={{sm:12, xs:12}} container className="mt-2 consplit_btns gap-3">
                                <button type="button" onClick={()=> navigate("/catalogs/global-services")} className='registersendbtn1'>Cancel</button>
                                <button type="submit" className='registersendbtn2'>{submitloader ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Submit'}</button>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
            </Grid>
            
        </div>
    </div>
  )
}

export default CreateOpportunity
